import dynamic from 'next/dynamic';

export const FindStorePage = dynamic(() => import('./find-store-page'));
